// extracted by mini-css-extract-plugin
export var aggregationCell = "_1g-f";
export var aggregationRow = "_1g-e";
export var borderlessSpinnerContainer = "_1g-2";
export var closeIcon = "_1g-7";
export var expandIcon = "_1g-8";
export var expanded = "_1g-9";
export var filterDropdown = "_1g-a";
export var filterDropdownDivider = "_1g-5";
export var filterDropdownHeader = "_1g-d";
export var filterDropdownItem = "_1g-c";
export var filterDropdownModal = "_1g-b _1g-a";
export var filterItem = "_1g-4";
export var normalCellWithAdjustableBorder = "_1g-6";
export var pinButtonContainer = "_1g-g";
export var pinIcon = "_1g-h";
export var pinIconActive = "_1g-i";
export var spinner = "_1g-0";
export var spinnerContainer = "_1g-1";
export var tableContainer = "_1g-3";
export var viewButtonContainer = "_1g-j";